__turbopack_context__.v({
  "fadeOverlay": "_2Mw3xa_fadeOverlay",
  "hidden": "_2Mw3xa_hidden",
  "resultsContainer": "_2Mw3xa_resultsContainer",
  "resultsWrapper": "_2Mw3xa_resultsWrapper",
  "searchDialog": "_2Mw3xa_searchDialog",
});
